import { LearnMoreLink } from '@ui/themed';
import { t } from 'i18next';
import { I18N_SCHEDULED_FOR_DELETION_ALERT_BAR } from '../constants';

export type ScheduledForDeletionAlertBarProps = {
  show: boolean;
};

export function ScheduledForDeletionAlertBar({ show }: ScheduledForDeletionAlertBarProps) {
  if (!show) return null;

  return (
    <div className="relative isolate z-20 flex flex-wrap items-center justify-center gap-1 overflow-hidden bg-orange-400 px-6 py-2.5 text-center text-[13px] text-white leading-4.5 sm:px-3.5">
      <span>{t(`${I18N_SCHEDULED_FOR_DELETION_ALERT_BAR}.message`)}</span>
      <LearnMoreLink link="https://docs.sparklayer.io/account-settings#jrRwC" />
    </div>
  );
}
